module.exports = __webpack_public_path__ + "assets/c13bb6dbaa5443d94f5ab04ae4d265df.mp3";